import React from 'react';
import SingleColumn from '@templates/SingleColumn';
import styles from './Videos.module.scss';
import Player from 'react-player';

export default function Videos() {
  return (
    <SingleColumn h1="Videos">
      {videos.map((video, index) => (
        <Video
          key={index}
          {...video}
        />
      ))}
    </SingleColumn>
  );
}

function Video({ title, url }) {
  return (
    <div className={styles.video}>
      {title && <h2 className="h3">{title}</h2>}
      <div className={styles.playerWrapper}>
        <Player
          url={url}
          width="100%"
          height="100%"
          className={styles.player}
          controls={true}
          config={{
            youtube: {
              playerVars: {
                rel: 0
              }
            }
          }}
        />
      </div>
    </div>
  );
}

const videos = [
  {
    title: '#infiniteLA: UCLA Climate Scientist Aradhna Tripati',
    url: '//www.youtube.com/watch?v=xGX_xxGJ6KU'
  },
  {
    title: 'The Center for Diverse Leadership in Science',
    url:
      'https://www.youtube.com/playlist?list=PL3k-oaCxhOmXitbwyipTEowKjzFB2Kmnu'
  },
  {
    title: 'Jimmy Kimmel Live',
    url: '//www.youtube.com/watch?v=9UCdFbyL8y0'
  },
  {
    title: 'North American Carbon World 2019',
    url: '//www.youtube.com/watch?v=bO5mCb7MKAM'
  },
  {
    title: 'Community college outreach and research in climate science',
    url: '//www.youtube.com/watch?v=rKi5JqBC68s'
  }
];
